/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-519bee2e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "color": "#3c6cfb"
  }
};
const _hoisted_2 = {
  class: "card-container"
};
import { apiGSIncomeCurrentList, apiGSIncomeData } from '@/api/gsManage';
import { useUserStore } from '@/store/modules/user';
import { useAppStore } from '@/store/modules/app';
import Player from './player.vue';
import Card from './card.vue';
import { storeToRefs } from 'pinia';
import SelectCurrency from '../modules/selectCurrency.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      userInfo
    } = storeToRefs(useUserStore());
    const {
      gameInfo
    } = storeToRefs(useAppStore());
    const activeCard = ref('income');
    const currencyList = ref();
    const panes = [{
      title: '我的收益',
      key: 'income'
    }];
    const currentCurrency = ref('USD');
    const inComeInfo = ref();
    const getCurrencyList = async () => {
      const res = await apiGSIncomeCurrentList({});
      if (res.code === 0) {
        currencyList.value = res.data;
      }
    };
    const getIncomeData = async () => {
      const res = await apiGSIncomeData({
        UserId: userInfo.value.Id,
        currency: currentCurrency.value,
        game_id: gameInfo.value.Id
      });
      if (res.code === 0) {
        inComeInfo.value = res.data;
      }
    };
    const handleChangeCurrency = () => {
      getIncomeData();
    };
    watch(() => gameInfo.value, val => {
      if (val) {
        getCurrencyList();
        getIncomeData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_u_card, {
        modelValue: _unref(activeCard),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(activeCard) ? activeCard.value = $event : null),
        panes: panes
      }, {
        extra: _withCtx(() => [_createVNode(SelectCurrency, {
          modelValue: _unref(currentCurrency),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(currentCurrency) ? currentCurrency.value = $event : null),
          onOnChange: handleChangeCurrency
        }, null, 8, ["modelValue"])]),
        "left-extra": _withCtx(() => {
          var _unref2;
          return [_createElementVNode("span", _hoisted_1, "分成比例 " + _toDisplayString(((_unref2 = _unref(inComeInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.gs_rate) / 100) + "%", 1)];
        }),
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "income"
        }, {
          default: _withCtx(() => {
            var _unref3, _unref4, _unref5;
            return [_createElementVNode("div", _hoisted_2, [_createVNode(Card, {
              count: (_unref3 = _unref(inComeInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.total_income,
              title: "总收益",
              unit: _unref(currentCurrency),
              class: "item"
            }, null, 8, ["count", "unit"]), _createVNode(Card, {
              count: (_unref4 = _unref(inComeInfo)) === null || _unref4 === void 0 ? void 0 : _unref4.month_income,
              title: "本月收益",
              unit: _unref(currentCurrency),
              class: "item"
            }, null, 8, ["count", "unit"]), _createVNode(Card, {
              count: (_unref5 = _unref(inComeInfo)) === null || _unref5 === void 0 ? void 0 : _unref5.today_income,
              title: "今日收益",
              unit: _unref(currentCurrency),
              class: "item"
            }, null, 8, ["count", "unit"])])];
          }),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(Player, {
        style: {
          "margin-top": "20px"
        },
        "user-id": _unref(userInfo).Id,
        "game-id": _unref(gameInfo).Id
      }, null, 8, ["user-id", "game-id"])], 64);
    };
  }
});